module.exports = __webpack_public_path__ + "gameSearch.png?ecf4a9ac4b6f25eae05137efcdba2cbc";